import React, { useState } from "react";
import { Card, CardTitle, SectionLabel } from "../ui/Card";
import TextField from "../ui/TextField";
import { formatAddress } from "../address";
import { isValidEmail, isValidPhone } from "../validation";
import AddressFields from "./AddressFields";
import DeliveryAddressField from "./DeliveryAddressField";

// When a customer is lodging (`isCustomer`), their address and delivery
// address are collected here.
export default function CustomerSection({
  form,
  protectedFetch,
  attempted = false,
  isCustomer = false,
}) {
  const { values, setField } = form;
  const [emailTouched, setEmailTouched] = useState(false);
  const [phoneTouched, setPhoneTouched] = useState(false);

  const showEmailError = emailTouched || attempted;
  const emailError = !showEmailError
    ? undefined
    : values.customerEmail === ""
      ? "Email is required"
      : !isValidEmail(values.customerEmail)
        ? "Enter a valid email address"
        : undefined;

  const showPhoneError = phoneTouched || attempted;
  const phoneError = !showPhoneError
    ? undefined
    : values.customerPhone === ""
      ? "Phone is required"
      : !isValidPhone(values.customerPhone)
        ? "Enter a valid phone number"
        : undefined;

  return (
    <Card radius="panel">
      <CardTitle>Customer</CardTitle>

      <div className="rma-nc-grid-2">
        <TextField
          label="First name"
          size="md"
          placeholder="e.g. John"
          value={values.customerFirstName}
          onChange={(event) => setField("customerFirstName", event.target.value)}
        />
        <TextField
          label="Last name"
          size="md"
          placeholder="e.g. Smith"
          value={values.customerLastName}
          onChange={(event) => setField("customerLastName", event.target.value)}
        />
        <div>
          <TextField
            label="Email"
            size="md"
            type="email"
            placeholder="e.g. name@example.com"
            value={values.customerEmail}
            onChange={(event) => setField("customerEmail", event.target.value)}
            onBlur={() => setEmailTouched(true)}
            className={emailError ? "rma-nc-control--error" : undefined}
          />
          {emailError && <p className="rma-nc-error-text">{emailError}</p>}
        </div>
        <div>
          <TextField
            label="Phone"
            size="md"
            type="tel"
            placeholder="e.g. 612 9123 4567"
            value={values.customerPhone}
            onChange={(event) => setField("customerPhone", event.target.value)}
            onBlur={() => setPhoneTouched(true)}
            className={phoneError ? "rma-nc-control--error" : undefined}
          />
          {phoneError && <p className="rma-nc-error-text">{phoneError}</p>}
        </div>
      </div>

      {isCustomer && (
        <>
          <SectionLabel>Address</SectionLabel>
          <AddressFields
            value={values.customerAddress}
            onChange={(address) => setField("customerAddress", address)}
            protectedFetch={protectedFetch}
            attempted={attempted}
          />

          {/* The retailer's delivery address field is hidden for customers, so it is asked here instead. */}
          <DeliveryAddressField
            className="rma-nc-mt-18"
            sameAsAbove={values.deliverySameAsAbove}
            onSameAsAboveChange={(checked) => setField("deliverySameAsAbove", checked)}
            aboveAddress={formatAddress(values.customerAddress, { includeCountry: false })}
            value={values.deliveryAddress}
            onChange={(address) => setField("deliveryAddress", address)}
            protectedFetch={protectedFetch}
            attempted={attempted}
          />
        </>
      )}
    </Card>
  );
}
